module.exports = __webpack_public_path__ + "media/scan_pay_tip.793f5db3.mp3";